// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Projects_mainContainer__163FN","projectMainContainer":"Projects_projectMainContainer__2kufz"};